
// Generar referencia bancaria
export const getRefBancaria = (entry) => {

    // console.log( entry);
    const result = [];
    const entryArray = [...entry];
    entryArray.reverse();

    entryArray.forEach( (value, index) => {

        (index % 2 === 0) ?
            ( 
                (value*2 > 9) ? 
                result[index] = value*2-9 
                : 
                result[index] = value*2 
            )
            :
            ( result[index] = value*1 )
    })

    const reducer = (accumulator, result) => accumulator + result;
    const sum = result.reduce(reducer);
    const res = (sum % 10 === 0) ? 10 : sum % 10;
    // console.log(sum);
    // console.log(res);

    return entry + (10 - res);
};
